import React from "react";
import { GIG_STATUS } from "@/lib/gig";

export default function GigStatusBadge({ status, testId }) {
  const meta = GIG_STATUS[status] || GIG_STATUS.accepting_applications;
  return (
    <span data-testid={testId}
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${meta.tone}`}>
      {meta.label}
    </span>
  );
}
